export default __webpack_public_path__ + "static/1-851a6f4e18e8af47f0a050aecc3b80df.jpeg";